'use strict'
import * as React from 'react'
import { useSelector } from 'react-redux'
import { titleName } from '../../../_constants/Code'
import Forbidden from '../../../_components/Forbidden'
import JudgmentRuleSettingContent from './JudgmentRuleSettingContent'
import { JudgmentRuleSettingProviderStore } from './extra/store'

/** 判定ルール設定画面 */
const JudgmentRuleSetting = () => {
  const state = useSelector((state) => state)

  // 権限チェック
  if (
    !state.authority.Master_AuthInfo.Availability ||
    !state.authority.Master_AuthInfo.Auth_Conf.DataMapping.JudgmentRule_Set
  ) {
    return <Forbidden />
  }

  return (
    <JudgmentRuleSettingProviderStore>
      <JudgmentRuleSettingContent
        pageTitle={titleName.judgmentRuleSetting + titleName.common}
        corporationNumber={state.company.corporationNumber}
        userId={state.user.sub}
        authority={state.authority}
      />
    </JudgmentRuleSettingProviderStore>
  )
}

export default JudgmentRuleSetting
